import { Trans, useTranslation } from "react-i18next";

import { Link } from "@/components/Interface/Link/Link";
import { Notification } from "@/components/Interface/Notification/Notification";
import { useSimIdFromQueryParam } from "@/hooks/useSimIdFromQueryParam";
import { portalRoutes } from "@/router/routes/portalRoutes";

/**
 * This component displays information about the roaming options.
 * It is displayed if the user has less than three roaming options booked.
 */
export const RoamingGoodToKnow = () => {
  const { t } = useTranslation(["portal", "translation"]);
  const [simId] = useSimIdFromQueryParam();

  return (
    <Notification
      dataTestid="roaming-good-to-know"
      title={t("translation:Content.goodToKnow")}
      description={
        <Trans
          t={t}
          components={[
            <Link
              key={0}
              size="sm"
              to={`${portalRoutes.manageDevice.voice}?simId=${simId}`}
              replace
            />,
          ]}
          i18nKey="portal:cockpit.managementTile.roaming.showOption.inactive.hint"
        />
      }
    />
  );
};
